import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function SkipAlert({ open, onClose, isFree = false }) {
  return (
    <Dialog onClose={onClose} aria-labelledby="skip-limit-title" open={open}>
      <DialogTitle id="skip-limit-title">
        {isFree ? (
          <>Donate & receive 30 Song Skips every hour!</>
        ) : (
          <>
            You have reached the maximum number of skips allowed for this
            channel (as per music licensing guidelines) for this hour.
          </>
        )}
        <IconButton
          aria-label="close"
          color="default"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <IoClose />
        </IconButton>
      </DialogTitle>
      <DialogActions sx={{ p: 2 }}>
        {isFree ? (
          <>
            <Button
              color="primary"
              sx={{ maxWidth: "fit-content" }}
              href="/donate"
            >
              Donate
            </Button>
          </>
        ) : (
          <>
            <Button
              color="primary"
              sx={{ maxWidth: "fit-content" }}
              onClick={() => onClose()}
            >
              Ok
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
